import React, { useRef, useState } from 'react';
import Modal from 'react-modal';
import { useModal, useModalUpdate, useModalContent }  from "../context/ModalContext";
// import { useModalScroll, useModalContent }  from "../context/MixContext";
// import { useData } from "../../components/context/DataContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { renderFormattedText } from "../../utils/helpers";
import { gaAudioButton, gaAudioProgress, gaTranscriptButtonClick } from '../../utils/gatags';

import './PopupModal.css'

import sound0 from '../../assets/audio/Webinar_clip_1_DrTore.mp3';
import sound1 from '../../assets/audio/Webinar_clip_2_DrCornes.mp3';
import sound2 from '../../assets/audio/Webinar_clip_4_DrCornes.mp3';
import sound3 from '../../assets/audio/Webinar_clip_5_DrCornes.mp3';
import sound4 from '../../assets/audio/Webinar_clip_3_ProfGreenberg.mp3';
import speakerimg0 from '../../assets/images/Kvein.png';
import speakerimg1 from '../../assets/images/Cornes1.png';
import speakerimg2 from '../../assets/images/Cornes2.png';
import speakerimg3 from '../../assets/images/Cornes3.png';
import speakerimg4 from '../../assets/images/Greenberg.png';

const PopupModal = () => {



    const audioElement = useRef(null);
    const modalState = useModal(true);
    const setModalState = useModalUpdate();
    const audioArray = [sound0,sound1,sound2,sound3,sound4];
    const speakerImgArray = [speakerimg0,speakerimg1,speakerimg2,speakerimg3,speakerimg4];
    const ModalItems = useModalContent();
    const [isVisible, setIsVisible] = useState(false);

    const audioStyles = {
      width: '100%',
      marginTop: '10px'
  };

    Modal.setAppElement('#root')

    const customStyles = {
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 40,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000
        },
        content : {
          position: 'relative',
          background: '#FFFFFF',
          inset: 0,
          margin: 20,
          overflow: 'unset',
          border: "none",
          borderTopRightRadius: 4
        }
      };


      // Audio metrics

      const [fired10Event, setFired10Event] = useState(false);
      const [fired20Event, setFired20Event] = useState(false);
      const [fired30Event, setFired30Event] = useState(false);
      const [fired40Event, setFired40Event] = useState(false);
      const [fired50Event, setFired50Event] = useState(false);
      const [fired60Event, setFired60Event] = useState(false);
      const [fired70Event, setFired70Event] = useState(false);
      const [fired80Event, setFired80Event] = useState(false);
      const [fired90Event, setFired90Event] = useState(false);
      const [fired100Event, setFired100Event] = useState(false);

      const onAudio = (_e, _audioaction) => {

        
        if ( _e.target.currentTime === 0 ) {
            setFired10Event(false);
            setFired20Event(false);
            setFired30Event(false);
            setFired40Event(false);
            setFired50Event(false);
            setFired60Event(false);
            setFired70Event(false);
            setFired80Event(false);
            setFired90Event(false);
            setFired100Event(false);
        }
        gaAudioButton(_e.target.src,  _audioaction);
      }

      const audioProgress = (e) => {

        let duration = e.target.duration;
        let currenttime = e.target.currentTime;

        

        if ( !fired10Event ) {
            if ( Math.round((currenttime / duration) * 100) >= 10 && Math.round((currenttime / duration) * 100) < 20 ) {
                // console.log("------------ 10%");
                setFired10Event(true);
                gaAudioProgress(10, e.target.src);
            }
        }
        if ( !fired20Event ) {
          if ( Math.round((currenttime / duration) * 100) >= 20 && Math.round((currenttime / duration) * 100) < 30 ) {
                // console.log("------------ 20%");
                setFired20Event(true);
                gaAudioProgress(20, e.target.src);
            }
        }
        if ( !fired30Event ) {
          if ( Math.round((currenttime / duration) * 100) >= 30 && Math.round((currenttime / duration) * 100) < 40 ) {
                // console.log("------------ 30%");
                setFired30Event(true);
                gaAudioProgress(30, e.target.src);
            }
        }
        if ( !fired40Event ) {
          if ( Math.round((currenttime / duration) * 100) >= 40 && Math.round((currenttime / duration) * 100) < 50 ) {
                // console.log("------------ 40%");
                setFired40Event(true);
                gaAudioProgress(40, e.target.src);
            }
        }
        if ( !fired50Event ) {
          if ( Math.round((currenttime / duration) * 100) >= 50 && Math.round((currenttime / duration) * 100) < 60 ) {
                // console.log("------------ 50%");
                setFired50Event(true);
                gaAudioProgress(50, e.target.src);
            }
        }
        if ( !fired60Event ) {
          if ( Math.round((currenttime / duration) * 100) >= 60 && Math.round((currenttime / duration) * 100) < 70 ) {
                // console.log("------------ 60%");
                setFired60Event(true);
                gaAudioProgress(60, e.target.src);
            }
        }
        if ( !fired70Event ) {
          if ( Math.round((currenttime / duration) * 100) >= 70 && Math.round((currenttime / duration) * 100) < 80 ) {
                // console.log("------------ 70%");
                setFired70Event(true);
                gaAudioProgress(70, e.target.src);
            }
        }
        if ( !fired80Event ) {
          if ( Math.round((currenttime / duration) * 100) >= 80 && Math.round((currenttime / duration) * 100) < 90 ) {
                // console.log("------------ 80%");
                setFired80Event(true);
                gaAudioProgress(80, e.target.src);
            }
        }
        if ( !fired90Event ) {
          if ( Math.round((currenttime / duration) * 100) >= 90 && Math.round((currenttime / duration) * 100) < 1000 ) {
                // console.log("------------ 90%");
                setFired90Event(true);
                gaAudioProgress(90, e.target.src);
            }
        }
        if ( !fired100Event ) {
            if ( Math.round((currenttime / duration) * 100) === 100 ) {
                // console.log("------------ 100%");
                setFired100Event(true);
                gaAudioProgress(100, e.target.src);
            }
        }
      }

      const transcriptMode = (_transcript) => {
        
        setIsVisible(!isVisible);
        gaTranscriptButtonClick(!isVisible);
        const transcriptEl = document.getElementsByClassName("btn"+_transcript);
      }

      // function openModal(){
      //   setModalState(true);
      // }

      function closeModal(){
        setModalState(false);
        setIsVisible(false);
      }

      function afterOpenModal(){
        // 
        setFired10Event(false);
        setFired20Event(false);
        setFired30Event(false);
        setFired40Event(false);
        setFired50Event(false);
        setFired60Event(false);
        setFired70Event(false);
        setFired80Event(false);
        setFired90Event(false);
        setFired100Event(false);
      }

      function afterClose(){
        // 
      }

    return (
      <Modal
            closeTimeoutMS={0}
            isOpen={ modalState }
            onAfterOpen={afterOpenModal}
            onAfterClose={afterClose}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            id="react-modal"
            >
              <div className="modal-header-transparent">
                <div className="close-btn-transparent" onClick={closeModal}><FontAwesomeIcon icon={faTimes} /></div>
              </div>
              <div id="modal-content" className="modal-content">
                <div className="modal-summary">
                  <div className="headshot">
                    <div className="headshot-border"></div>
                    <img src={speakerImgArray[ModalItems && ModalItems.idx]} width="106" height="106" alt="Speaker" />
                  </div>
                  <div className="overview">
                      {renderFormattedText(ModalItems && ModalItems.summary, null)}
                  </div>
                </div>


                <AudioPlayer 
                  id="audio-player"
                  ref={audioElement} 
                  controls={true} 
                  src={audioArray[ModalItems && ModalItems.idx]} 
                  style={audioStyles} 
                  listenInterval="500"
                  onPlay={e => onAudio(e, "play")} 
                  onPause={e => onAudio(e, "pause")}
                  onListen={audioProgress}
                  />
                    <div className="audio-biog-wrap">
                      <div className="transcript-btn" onClick={ e => transcriptMode(ModalItems && ModalItems.idx) }>
                        <div className="transcript-btn-icon"></div>
                        <div className="transcript-btn-txt">Audio Transcript</div>
                      </div>

                      {isVisible && (
                        renderFormattedText(ModalItems && ModalItems.transcript, "trans-txt")
                      )}
                    </div>
                    
              </div>
              
        </Modal>
    );
};


export default PopupModal;